import "./TutorRegistration.scss";
import "react-phone-number-input/style.css";
import { Field, Form, Formik } from "formik";
import * as yup from "yup";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setLanguage } from "../../../Services/Redux/Reducer/Reducer";
import {
  ERROR_MESSAGES,
  REGEX,
} from "../../../Utilities/Constants/Validations";
import { axiosInstance } from "../../../Services/Interceptor/Interceptor";
import API_END_POINTS from "../../../Utilities/Constants/ApiEndpoints";
import LanguageIcon from "@mui/icons-material/Language";
import {
  TOASTER_CONFIGS,
  API_RESPONSE,
  LANGUAGES,
  LAYOUTS,
  ROUTES,
  AUTHENTICATION_LABELS,
  TUTOR_REGISTRATION_FIELDS,
  TUTOR_TYPE,
  STORAGE_KEYS,
  I18_TRANSLATION_COMMON,
  NUMBER_CONSTANTS,
} from "../../../Utilities/Constants/Constants";
import { useNavigate } from "react-router";
import PhoneInput from "react-phone-number-input";
import passwordVisible from "../../../../Assets/Login/password_visible.svg";
import passwordInvisible from "../../../../Assets/Login/password_invisible.svg";
import { toast } from "react-toastify";
import { useState } from "react";
import { SetSessionStorageData } from "../../../Services/Helpers/Helper";

const TutorRegistration = () => {
  /* Password visibility states**/
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  /* Translation hook**/
  const { t, i18n } = useTranslation(I18_TRANSLATION_COMMON.COMMON);
  /* Navigatoin hook**/
  const navigate = useNavigate();
  /* Toggle language**/
  const changeLanguage = (languageCode: string) => {
    dispatch(
      setLanguage(
        language === LANGUAGES.ENGLISH ? LANGUAGES.ARABIC : LANGUAGES.ENGLISH
      )
    );
    i18n.changeLanguage(languageCode);
  };
  /* set and get language from redux**/
  const dispatch = useDispatch();
  const language: any = useSelector((state: any) => {
    return state.languageReducer.language;
  });
  /* Login field initial values **/
  let registerInitialValue = {
    tutorType: "",
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    password: "",
    confirmPassword: "",
  };

  /* login fields validation schema **/
  const registerValidationSchema = yup.object({
    tutorType: yup.string().required(ERROR_MESSAGES.TUTOR_TYPE_REQUIRED),
    firstName: yup.string().required(ERROR_MESSAGES.NAME_REQUIRED),
    lastName: yup.string().required(ERROR_MESSAGES.NAME_REQUIRED),
    email: yup
      .string()
      .required(ERROR_MESSAGES.EMAIL_REQUIRED)
      .matches(REGEX.EMAIL, ERROR_MESSAGES.INVALID_EMAIL)
      .email(ERROR_MESSAGES.INVALID_EMAIL),
    mobile: yup.string().required(ERROR_MESSAGES.PHONE_NUMBER),
    password: yup
      .string()
      .required(ERROR_MESSAGES.PASSWORD_REQUIRED)
      .min(NUMBER_CONSTANTS.EIGHT, ERROR_MESSAGES.MINIMUM_PASSWORD)
      .max(NUMBER_CONSTANTS.SIXTEEN, ERROR_MESSAGES.MAXIMUM_PASSWORD)
      .matches(REGEX.PASSWORD, ERROR_MESSAGES.INVALID_PASSWORD),
    confirmPassword: yup
      .string()
      .required(ERROR_MESSAGES.PASSWORD_REQUIRED)
      .min(NUMBER_CONSTANTS.EIGHT, ERROR_MESSAGES.MINIMUM_PASSWORD)
      .max(NUMBER_CONSTANTS.SIXTEEN, ERROR_MESSAGES.MAXIMUM_PASSWORD)
      .matches(REGEX.PASSWORD, ERROR_MESSAGES.INVALID_PASSWORD)
      .oneOf([yup.ref("password")], ERROR_MESSAGES.REGISTER_PASSWORD_MATCH),
  });
  /**register payload */
  const getRegisterPayload = (values: any) => {
    return {
      firstname: values[TUTOR_REGISTRATION_FIELDS.FIRST_NAME],
      lastname: values[TUTOR_REGISTRATION_FIELDS.LAST_NAME],
      email: values[TUTOR_REGISTRATION_FIELDS.EMAIL],
      phone_number: values[TUTOR_REGISTRATION_FIELDS.MOBILE],
      roles: values[TUTOR_REGISTRATION_FIELDS.TUTOR_TYPE],
      image: "",
      is_social: `${NUMBER_CONSTANTS.ZERO}`,
      social_id: "",
      language: `${LANGUAGES.ENGLISH}`,
      password: values[TUTOR_REGISTRATION_FIELDS.PASSWORD],
    };
  };
  /* login API call **/
  const login = (values: any, actions: any) => {
    axiosInstance
      .post(`${API_END_POINTS.TUTOR_REGISTRATION}`, getRegisterPayload(values))
      .then((response: any) => {
        if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
          SetSessionStorageData(
            STORAGE_KEYS.EMAIL,
            response.data.result.data.user_info.email
          );
          toast.success(response.data.message, TOASTER_CONFIGS);
          navigate(ROUTES.OTP_VERIFICATION)
        }
      })
      .catch((error: any) => {});
  };
  return (
    <>
      <div
        className="tutor_registration_container"
        dir={language === LANGUAGES.ENGLISH ? LAYOUTS.LTR : LAYOUTS.RTL}
      >
        <div className="language_switch_header">
          <div className=" language_switch_contianer">
            <LanguageIcon className="language_icon" />
            <button
              className="language_button"
              onClick={() => {
                changeLanguage(
                  language === LANGUAGES.ENGLISH
                    ? LANGUAGES.ARABIC_ABBRIVATION
                    : LANGUAGES.ENGLISH_ABBRIVATION
                );
              }}
            >
              {language === LANGUAGES.ENGLISH
                ? LANGUAGES.ARABIC
                : LANGUAGES.ENGLISH}
            </button>
          </div>
        </div>
        <div className="login_wrapper ">
          <div className="login_fields_wrapper">
            <div className="login_fields_container">
              <div className="login_label_fields">
                <p className="login_description ">{t("Create your account")}</p>
                <Formik
                  initialValues={registerInitialValue}
                  validationSchema={registerValidationSchema}
                  onSubmit={(values, actions) => {
                    login(values, actions);
                  }}
                  enableReinitialize={true}
                >
                  {(formik) => (
                    <Form>
                      <div className="email_password_fields_container">
                        <div className="email_password_fields">
                          <Field
                            as="select"
                            className={
                              formik.values.tutorType === ""
                                ? "tutor_type_placeholder"
                                : ""
                            }
                            name={TUTOR_REGISTRATION_FIELDS.TUTOR_TYPE}
                            id={TUTOR_REGISTRATION_FIELDS.TUTOR_TYPE}
                          >
                            <option hidden value="default">
                              {t("Tutor Type")}
                            </option>
                            {TUTOR_TYPE.map(
                              (tutorTypeElements: any, index: any) => {
                                return (
                                  <option
                                    className="tutor_type"
                                    key={index}
                                    value={tutorTypeElements.value}
                                  >
                                    {t(tutorTypeElements.label)}
                                  </option>
                                );
                              }
                            )}
                          </Field>
                          {formik.touched.tutorType &&
                          formik.errors.tutorType ? (
                            <div className="errorMessage">
                              {t(`${formik.errors.tutorType}`)}
                            </div>
                          ) : null}
                        </div>
                        <div className="email_password_fields">
                          <Field
                            placeholder={t("First Name")}
                            name={TUTOR_REGISTRATION_FIELDS.FIRST_NAME}
                          />
                          {formik.touched.firstName &&
                          formik.errors.firstName ? (
                            <div className="errorMessage">
                              {t(`${formik.errors.firstName}`)}
                            </div>
                          ) : null}
                        </div>
                        <div className="email_password_fields">
                          <Field
                            placeholder={t("Last Name")}
                            name={TUTOR_REGISTRATION_FIELDS.LAST_NAME}
                          />
                          {formik.touched.lastName && formik.errors.lastName ? (
                            <div className="errorMessage">
                              {t(`${formik.errors.lastName}`)}
                            </div>
                          ) : null}
                        </div>
                        <div className="email_password_fields">
                          <Field
                            placeholder={t("Email")}
                            name={TUTOR_REGISTRATION_FIELDS.EMAIL}
                          />
                          {formik.touched.email && formik.errors.email ? (
                            <div className="errorMessage">
                              {t(`${formik.errors.email}`)}
                            </div>
                          ) : null}
                        </div>
                        <div className="email_password_fields">
                          <PhoneInput
                            className="mobile_number"
                            placeholder={t("Phone Number")}
                            onChange={(mobileEvent) => {
                              formik.setFieldValue(
                                TUTOR_REGISTRATION_FIELDS.MOBILE,
                                mobileEvent
                              );
                            }}
                          />
                          {formik.touched.mobile && formik.errors.mobile ? (
                            <div className="errorMessage">
                              {t(`${formik.errors.mobile}`)}
                            </div>
                          ) : null}
                        </div>
                        <div
                          className={
                            language === LANGUAGES.ENGLISH
                              ? "password_field"
                              : "password_field_arabic"
                          }
                        >
                          <div className="password_container">
                            <Field
                              placeholder={t("Password")}
                              type={showPassword ? "text" : "password"}
                              name={TUTOR_REGISTRATION_FIELDS.PASSWORD}
                            />
                            <img
                              className={
                                language === LANGUAGES.ENGLISH
                                  ? "password_visibility"
                                  : "password_visibility_arabic"
                              }
                              onClick={() => {
                                setShowPassword(!showPassword);
                              }}
                              src={
                                showPassword
                                  ? passwordInvisible
                                  : passwordVisible
                              }
                              alt=""
                            />
                          </div>
                          {formik.touched.password && formik.errors.password ? (
                            <div className="errorMessage">
                              {t(`${formik.errors.password}`)}
                            </div>
                          ) : null}
                        </div>
                        <div
                          className={
                            language === LANGUAGES.ENGLISH
                              ? "password_field"
                              : "password_field_arabic"
                          }
                        >
                          <div className="password_container">
                            <Field
                              placeholder={t("Confirm Password")}
                              type={showConfirmPassword ? "text" : "password"}
                              name={TUTOR_REGISTRATION_FIELDS.CONFIRM_PASSWORD}
                            />
                            <img
                              className={
                                language === LANGUAGES.ENGLISH
                                  ? "password_visibility"
                                  : "password_visibility_arabic"
                              }
                              onClick={() => {
                                setShowConfirmPassword(!showConfirmPassword);
                              }}
                              src={
                                showConfirmPassword
                                  ? passwordInvisible
                                  : passwordVisible
                              }
                              alt=""
                            />
                          </div>
                          {formik.touched.confirmPassword &&
                          formik.errors.confirmPassword ? (
                            <div className="errorMessage">
                              {t(`${formik.errors.confirmPassword}`)}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <button className="submit_button" type="submit">
                        {t("Submit")}
                      </button>
                      <div className="sign_up_button_wrapper">
                        {t(AUTHENTICATION_LABELS.ALREADY_HAVE_AN_ACCOUNT)}
                        <button
                          onClick={() => navigate(ROUTES.LOGIN)}
                          type="button"
                          className="sign_up"
                        >
                          {t(AUTHENTICATION_LABELS.LOGIN)}
                        </button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TutorRegistration;
